import { TranslationVehiclesModuleMessages, VehiclesModuleMessages } from "../interfaces";

export const messages: TranslationVehiclesModuleMessages = {
  // region Backend messages

  // region Vehicle-events messages
  [VehiclesModuleMessages.updateVehicleEventSuccess]: "Evento alterado com sucesso",
  [VehiclesModuleMessages.eventNotFound]: "Evento não cadastrado em nosso sistema",
  [VehiclesModuleMessages.updateVehicleEventError]: "Falha ao atualizar evento",
  [VehiclesModuleMessages.readVehicleEventSuccess]: "Evento(s) retornado(s) com sucesso",
  [VehiclesModuleMessages.noVehicleEventFound]: "Nenhum evento cadastrado para a viagem em questão",
  [VehiclesModuleMessages.readVehicleEventError]: "Falha ao buscar evento(s)",
  // endregion
  // region Vehicles-states messages
  [VehiclesModuleMessages.createVehicleStateSuccess]: "Estado de veículo cadastrado com sucesso",
  [VehiclesModuleMessages.createVehicleStateError]: "Falha ao cadastrar estado de veículo",
  [VehiclesModuleMessages.readVehicleStateSuccess]: "Estado(s) de veículo retornado(s) com sucesso",
  [VehiclesModuleMessages.noVehicleStateFound]: "Nenhum estado de veículo cadastrado",
  [VehiclesModuleMessages.readVehicleStateError]: "Falha ao buscar estado(s) de veículo(s)",
  [VehiclesModuleMessages.noVehicleStateInTravelFound]: "Nenhum estado de veículo cadastrado para a viagem em questão",
  [VehiclesModuleMessages.getVehiclesAndTravelsError]: "Falha ao buscar informações dos veículos e viagens",
  [VehiclesModuleMessages.getVehiclesHardwaresError]: "Falha ao buscar informações dos hardwares dos veículos",
  [VehiclesModuleMessages.getVehiclesAlertsError]: "Falha ao buscar informações dos alertas dos veículos",
  [VehiclesModuleMessages.getMixerTravelsSpecificInfoError]: "Falha ao buscar informações específicas das viagens de betoneira",
  [VehiclesModuleMessages.getPumpTravelsSpecificInfoError]: "Falha ao buscar informações específicas das viagens de bomba",
  [VehiclesModuleMessages.getAggregateTruckTravelsSpecificInfoError]: "Falha ao buscar informações específicas das viagens de caminhão de agregado",
  [VehiclesModuleMessages.noVehicleStateInVehicleFound]: "Nenhum estado de veículo cadastrado para o veículo ",
  // endregion
  // region Vehicle-states-types messages
  [VehiclesModuleMessages.readVehicleStateTypeSuccess]: "Tipo(s) de estados de veículo retornado(s) com sucesso",
  [VehiclesModuleMessages.noVehicleStateTypeFound]: "Nenhum tipo de estado de veículo cadastrado",
  [VehiclesModuleMessages.readVehicleStateTypeError]: "Falha ao buscar tipo(s) de estado(s) de veículo(s)",
  // endregion
  // region Vehicle-types messages
  [VehiclesModuleMessages.readVehicleTypeSuccess]: "Tipo(s) de veículo(s) retornado(s) com sucesso",
  [VehiclesModuleMessages.noVehicleTypeFound]: "Nenhum tipo de veículo cadastrado",
  [VehiclesModuleMessages.readVehicleTypeError]: "Falha ao buscar tipo(s) de veículo(s)",
  // endregion
  // region Vehicles messages
  [VehiclesModuleMessages.createVehicleSuccess]: "Veículo cadastrado com sucesso",
  [VehiclesModuleMessages.createVehicleError]: "Falha ao cadastrar veículo",
  [VehiclesModuleMessages.readVehicleSuccess]: "Veículo(s) retornado(s) com sucesso",
  [VehiclesModuleMessages.noVehicleFound]: "Nenhum veículo encontrado",
  [VehiclesModuleMessages.readVehicleError]: "Falha ao buscar veículo(s)",
  [VehiclesModuleMessages.updateVehicleSuccess]: "Veículo alterado com sucesso",
  [VehiclesModuleMessages.vehicleNotFound]: "Veículo não cadastrado em nosso sistema",
  [VehiclesModuleMessages.updateVehicleError]: "Falha ao atualizar veículo",
  [VehiclesModuleMessages.deleteVehicleSuccess]: "Veículo excluído com sucesso",
  [VehiclesModuleMessages.onlyInactivateVehicleMessage]: "Veículo com mais de um estado não pode ser excluído, apenas inativado",
  [VehiclesModuleMessages.deleteVehicleError]: "Falha ao excluir veículo",
  [VehiclesModuleMessages.code]: "Código",
  [VehiclesModuleMessages.licensePlate]: "Placa",
  [VehiclesModuleMessages.invalidUserOrPassword]: "Usuário ou senha inválidos",
  [VehiclesModuleMessages.userNotAuthorizedToBlockVehicle]: "Usuário não autorizado a bloquear veículo",
  [VehiclesModuleMessages.vehicleWithoutHardware]: "Veículo não possui hardware",
  [VehiclesModuleMessages.vehicleWithoutBlockCapableHardware]: "Veículo não possui hardware com bloqueio",
  [VehiclesModuleMessages.blockRequestSent]: "Bloqueio solicitado com sucesso",
  [VehiclesModuleMessages.unblockRequestSent]: "Desbloqueio solicitado com sucesso",
  [VehiclesModuleMessages.blockRequestError]: "Falha ao solicitar bloqueio/desbloqueio",
  [VehiclesModuleMessages.getVehicleInfoSuccess]: "Informações do veículo retornadas com sucesso",
  [VehiclesModuleMessages.getVehicleInfoError]: "Falha ao buscar informações do veículo",
  [VehiclesModuleMessages.updateVehicleConfigSuccess]: "Configuração do veículo atualizada com sucesso",
  [VehiclesModuleMessages.updateVehicleConfigError]: "Falha ao atualizar configuração do veículo",
  [VehiclesModuleMessages.batchUpdateMaxSpeedSuccess]: "Velocidade máxima atualizada com sucesso",
  [VehiclesModuleMessages.batchUpdateMaxSpeedError]: "Falha ao atualizar velocidade máxima dos veículos",
  [VehiclesModuleMessages.general]: "Geral",
  [VehiclesModuleMessages.total]: "Total",
  [VehiclesModuleMessages.average]: "Média",

  // region Vehicle types
  [VehiclesModuleMessages.concreteMixers]: "Betoneiras",
  [VehiclesModuleMessages.concreteMixer]: "Betoneira",
  [VehiclesModuleMessages.pumpTrucks]: "Caminhões bomba",
  [VehiclesModuleMessages.pumpTruck]: "Caminhão bomba",
  [VehiclesModuleMessages.supportVehicles]: "Veículos de apoio",
  [VehiclesModuleMessages.supportVehicle]: "Veículo de apoio",
  [VehiclesModuleMessages.loaders]: "Pás carregadeiras",
  [VehiclesModuleMessages.loader]: "Pá carregadeira",
  [VehiclesModuleMessages.aggregateTrucks]: "Carretas de agregados",
  [VehiclesModuleMessages.aggregateTruck]: "Carreta de agregados",
  [VehiclesModuleMessages.siloTrucks]: "Carretas silo",
  [VehiclesModuleMessages.siloTruck]: "Carreta silo",
  // endregion

  // endregion
  // region Integration messages
  [VehiclesModuleMessages.locationNotRegistered]: "Local(is) não cadastrado(s)",
  [VehiclesModuleMessages.driverNotRegistered]: "Motorista(s) não cadastrado(s)",
  [VehiclesModuleMessages.externalIDAlreadyRegistered]: "ID(s) externos já cadastrado(s)",
  [VehiclesModuleMessages.licensePlateAlreadyRegistered]: "Placa(s) já cadastrada(s)",
  [VehiclesModuleMessages.codeAlreadyRegistered]: "Código(s) já cadastrado(s)",
  [VehiclesModuleMessages.invalidDateFormat]: "Formato de data inválido",
  [VehiclesModuleMessages.noDataForThisVehicleOrDay]: "Não há dados para esse veículo e/ou dia",
  [VehiclesModuleMessages.readVehicleDailySummarySuccess]: "Resumo diário do(s) veículo(s) obtido(s) com sucesso",
  [VehiclesModuleMessages.vehicleWithoutTracker]: "Veículo sem rastreador vinculado",
  [VehiclesModuleMessages.invalidTrackerReadingsRange]: "Período inválido. Informe start_date e finish_date, com no máximo 1 dia entre elas",
  [VehiclesModuleMessages.invalidVehicleHistoryDateRange]: "Intervalo de datas inválido. Máximo permitido: 60 dias",
  [VehiclesModuleMessages.readTrackerReadingsSuccess]: "Leituras do rastreador obtidas com sucesso",
  // endregion

  // endregion
  // region Frontend messages

  // region General
  [VehiclesModuleMessages.description]: "Descrição",
  [VehiclesModuleMessages.status]: "Status",
  [VehiclesModuleMessages.odometer]: "Odômetro",
  [VehiclesModuleMessages.odometerInKm]: "Odômetro (km)",
  [VehiclesModuleMessages.hourMeter]: "Horímetro",
  [VehiclesModuleMessages.hourMeterInHours]: "Horímetro (h)",
  [VehiclesModuleMessages.maintenance]: "Em manutenção",
  [VehiclesModuleMessages.originalAllocation]: "Alocação original",
  [VehiclesModuleMessages.currentAllocation]: "Alocação atual",
  [VehiclesModuleMessages.currentEvent]: "Evento atual",
  [VehiclesModuleMessages.searchingVehicles]: "Buscando veículos...",
  [VehiclesModuleMessages.vehicleDeleteConfirmation]: "Tem certeza que deseja excluir o veículo",
  [VehiclesModuleMessages.vehicleRegistration]: "Cadastro de veículo",
  [VehiclesModuleMessages.activeVehicle]: "Veículo ativo",
  [VehiclesModuleMessages.active]: "Ativo",
  [VehiclesModuleMessages.inactive]: "Inativo",
  [VehiclesModuleMessages.vehicleUnderMaintenance]: "Veículo em manutenção",
  [VehiclesModuleMessages.vehicleType]: "Tipo de veículo",
  [VehiclesModuleMessages.maxSpeedAllowed]: "Velocidade máxima permitida",
  [VehiclesModuleMessages.maxSpeedAllowedTooltip]: "O alerta de velocidade será gerado considerando uma variação de até 5% acima do valor configurado.",
  [VehiclesModuleMessages.allocationPlant]: "Usina de alocação",
  [VehiclesModuleMessages.defaultDriver]: "Motorista padrão",
  [VehiclesModuleMessages.title]: "Veículos",
  [VehiclesModuleMessages.deleteDialogTitle]: "Confirmação de exclusão",
  [VehiclesModuleMessages.vehicles]: "Veículos",
  [VehiclesModuleMessages.blocks]: "Bloqueios",
  [VehiclesModuleMessages.group]: "Grupo",
  [VehiclesModuleMessages.regional]: "Regional",
  [VehiclesModuleMessages.plant]: "Usina",
  [VehiclesModuleMessages.lastCommunicationDate]: "Data da última comunicação",
  [VehiclesModuleMessages.lastCommunication]: "Última comunicação",
  [VehiclesModuleMessages.ignition]: "Ignição",
  [VehiclesModuleMessages.lastIgnitionDate]: "Última ignição",
  [VehiclesModuleMessages.lastPlantExitDate]: "Última saída da usina",
  [VehiclesModuleMessages.currentLatitude]: "Latitude atual",
  [VehiclesModuleMessages.currentLongitude]: "Longitude atual",
  [VehiclesModuleMessages.currentAddress]: "Endereço atual",
  [VehiclesModuleMessages.activeHardware]: "GPS ativo",
  [VehiclesModuleMessages.analyticReport]: "Relatório analítico",
  [VehiclesModuleMessages.batchChangeMaxSpeed]: "Alterar velocidade máxima em lote",
  [VehiclesModuleMessages.batchChangeMaxSpeedDialogTitle]: "Alterar velocidade máxima",
  [VehiclesModuleMessages.batchChangeMaxSpeedConfirmation]: "Tem certeza que deseja alterar a velocidade máxima dos veículos selecionados?",
  [VehiclesModuleMessages.batchChangeMaxSpeedCancelSelection]: "Cancelar seleção",
  [VehiclesModuleMessages.batchChangeMaxSpeedVehiclesList]: "Veículos a serem atualizados:",
  // endregion General
  // region Vehicle Config
  [VehiclesModuleMessages.vehicleCANParameters]: "Parâmetros CAN do Veículo",
  [VehiclesModuleMessages.fuelTankSize]: "Capacidade do tanque de combustível (L)",
  [VehiclesModuleMessages.fuelTankSizeEstimated]: "Capacidade estimada automaticamente (L)",
  [VehiclesModuleMessages.fuelTankSizeEstimatedAt]: "estimada em",
  [VehiclesModuleMessages.fuelTankSizeEstimatedTooltip]: "Calculada pela calibração de consumo do veículo. Se a capacidade for informada acima, a informada prevalece e esta fica como referência.",
  [VehiclesModuleMessages.resetFuelTankEstimate]: "Recalcular estimativa",
  [VehiclesModuleMessages.resetFuelTankEstimateConfirm]: "Isso apaga a estimativa atual e o aprendizado de calibração — o sistema volta a estimar do zero nos próximos dias de operação. Deseja continuar?",
  [VehiclesModuleMessages.resetFuelTankEstimateSuccess]: "Estimativa da capacidade do tanque reiniciada com sucesso",
  [VehiclesModuleMessages.resetFuelTankEstimateError]: "Erro ao reiniciar a estimativa da capacidade do tanque",
  [VehiclesModuleMessages.maxTemperatureLimit]: "Limite máximo de temperatura (°C)",
  [VehiclesModuleMessages.harshAccelerationThreshold]: "Aceleração brusca a partir de (m/s²)",
  [VehiclesModuleMessages.harshBrakingThreshold]: "Frenagem brusca a partir de (m/s²)",
  [VehiclesModuleMessages.harshCorneringThreshold]: "Curva acentuada a partir de (m/s²)",
  [VehiclesModuleMessages.maxRpmLimit]: "Limite máximo de RPM",
  [VehiclesModuleMessages.vehicleCANParametersUpdateSuccess]: "Parâmetros CAN atualizados com sucesso",
  [VehiclesModuleMessages.vehicleCANParametersLoadError]: "Erro ao carregar configurações",
  // endregion
  // region Water Factor Control
  [VehiclesModuleMessages.waterFactorControlTitle]: "Controle do fator de água",
  [VehiclesModuleMessages.waterFactorControlTab]: "Controle",
  [VehiclesModuleMessages.waterFactorHistoryTab]: "Histórico",
  [VehiclesModuleMessages.vehicleWithoutHardwareTooltip]: "Veículo sem hardware vinculado",
  [VehiclesModuleMessages.controlTabExplanatoryText]: "Para iniciar o procedimento de calibração, clique no botão de iniciar análise e posterior "
    + "ao início adicione uma quantidade precisamente conhecida de água no balão. Em seguida, interrompa a análise no sistema, alocando a "
    + "quantidade no campo informado e acione o botão de calcular e salvar.\n\n"
    + "O sistema utilizará os dados coletados durante este período para calcular o novo fator de correção (ou fator de calibração), "
    + "o qual será exibido na tela como o resultado final do processo.",
  [VehiclesModuleMessages.controlTabHardwareBrand]: "Marca",
  [VehiclesModuleMessages.controlTabHardwareModel]: "Modelo",
  [VehiclesModuleMessages.controlTabHardwareDevId]: "ID do dispositivo",
  [VehiclesModuleMessages.controlTabAnalysisPeriod]: "Período de análise",
  [VehiclesModuleMessages.controlTabStartAnalysis]: "Iniciar análise",
  [VehiclesModuleMessages.controlTabStopAnalysis]: "Parar análise",
  [VehiclesModuleMessages.controlTabResetAnalysis]: "Reiniciar análise",
  [VehiclesModuleMessages.controlTabAmountOfWater]: "Quantidade de água adicionada (L)",
  [VehiclesModuleMessages.controlTabCalculateButton]: "Calcular e salvar",
  [VehiclesModuleMessages.controlTabHardwareOffline]: "O hardware do veículo está offline há mais de 30 minutos. "
    + "Não é possível iniciar a análise.",
  [VehiclesModuleMessages.waterFactorResultTitle]: "Cálculo concluído com sucesso!",
  [VehiclesModuleMessages.waterFactorResultPreviousFactor]: "Fator anterior:",
  [VehiclesModuleMessages.waterFactorResultHardwareWater]: "Água (Hardware):",
  [VehiclesModuleMessages.waterFactorResultUserWater]: "Água (Informada):",
  [VehiclesModuleMessages.waterFactorResultNewCalibration]: "Realizar nova calibração",
  [VehiclesModuleMessages.waterFactorSourceIntelligentSuggestion]: "Sugestão inteligente",
  [VehiclesModuleMessages.waterFactorSourceManual]: "Manual",
  [VehiclesModuleMessages.waterFactorSourceRevert]: "Reversão",
  [VehiclesModuleMessages.historyTabCurrentWaterFactor]: "Fator de água",
  [VehiclesModuleMessages.historyTabPreviousWaterFactor]: "Fator de água anterior",
  [VehiclesModuleMessages.historyTabSourcedFrom]: "Fonte",
  [VehiclesModuleMessages.historyTabChangedByUser]: "Alterado por",
  [VehiclesModuleMessages.historyTabChangedDate]: "Data da alteração",
  [VehiclesModuleMessages.historyTabStatus]: "Status",
  [VehiclesModuleMessages.historyTabActions]: "Ações",
  [VehiclesModuleMessages.historyTabActiveText]: "Ativo",
  [VehiclesModuleMessages.historyTabTooltipActiveText]: "Esta versão já está ativa",
  [VehiclesModuleMessages.historyTabRevertButton]: "Reverter"
  // endregion Water Factor Control

  // endregion
};
